import * as React from "react";
import { connect } from "react-redux";
import LoadingFullScreen from "../../../components/LoadingFullScreen";
import { RootState } from "../../types";
import { editPatient } from "../actions";
import PatientAddEdit from "../components/PatientAddEdit";
import { getLocations } from "../../dashboard/actions";
import { Patient, PatientFormParams } from "../types";
import { FormikErrors } from "formik";

interface StoreProps {
  loading: boolean;
  locations: string[];
  patient: Patient | null;
}

interface DispatchProps {
  editPatient: (
    params: PatientFormParams,
    onError: (error: FormikErrors<PatientFormParams>) => void,
    id?: string
  ) => void;
  getLocations: () => void;
}

interface OwnState {
  isBusy: boolean;
}

type Props = OwnState & DispatchProps & StoreProps;

class PatientEditContainer extends React.PureComponent<Props, OwnState> {
  public constructor(props: Props) {
    super(props);

    this.state = {
      isBusy: false
    };
  }

  public render() {
    const { loading, patient } = this.props;

    return (
      <>
        {loading && <LoadingFullScreen />}
        <PatientAddEdit
          patient={patient || undefined}
          actionText="Update Patient"
          action={this.props.editPatient}
          locations={this.props.locations}
        />
      </>
    );
  }
}

export default connect<StoreProps, DispatchProps, {}, RootState>(
  state => ({
    loading: state.patientdetail.loading,
    locations: state.dashboard.data.locations,
    patient: state.patientdetail.data.patient
  }),
  {
    editPatient,
    getLocations
  }
)(PatientEditContainer);
